import styled from '@emotion/styled';
import { token } from '@atlaskit/tokens';

export const CreateCustomerWrapperContainer = styled.div<{ isAddressStage?: boolean }>`
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: ${(props) => (props.isAddressStage ? token('space.0') : token('space.300'))};
  padding-top: 0;

  #create-customer-header {
    padding-inline: ${(props) => (props.isAddressStage ? token('space.300') : token('space.0'))};
  }

  // override padding from ShipToPartySidebar component
  .pane-sidebar-content {
    padding: 0 !important; // to remove padding from ShipToPartySidebar component

    > form {
      > div {
        padding: ${token('space.300')};
        padding-top: 0;
      }
    }

    .form-footer {
      position: sticky;
      bottom: 0;
      background-color: ${token('elevation.surface')};
      padding: ${token('space.300')} !important;
      padding-top: ${token('space.150')} !important;
      margin-top: 0 !important;
    }

    #add-another-address {
      padding-inline: 0 !important;
    }
  }
  // override ends

  #footer {
    margin-top: auto;
  }
`;

export const CreateCustomerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CreateCustomerBody = styled.div`
  height: 100%;
  flex: 1;
`;

export const CompanyNameInputForm = styled.form`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
